export default ['real', 'exclusive'];
